import AbstractHttpService from "./AbstractHttpService";
import * as CheersInterface from "../../interfaces/api/CheersApiService";
import { Cheer as CheerApi } from "src/common/dto/Cheer";
import { Cheer } from "src/common/interfaces/Cheer";
import { getCheerersPeriod } from "../.../../../../common/constants/getCheerersPeriod";

class CheersApiService extends AbstractHttpService {
  portCheerFromApi(cheer: CheerApi): Cheer {
    return {
      ...cheer,
      createdAt: new Date(cheer.createdAt),
    };
  }

  getEmotes(form: CheersInterface.GetEmotesForm): Promise<CheersInterface.GetEmotesResponse> {
    return this.http
      .get(`channels/${form.channelId}/emotes`)
      .then(this.resolve)
      .then(({ json }) => json as CheersInterface.GetEmotesResponse)
      .catch(this.reject);
  }

  postCheer(cheer: CheersInterface.PostCheerForm): Promise<CheersInterface.PostCheerResponse> {
    return this.http
      .post(`cheers`, { json: cheer })
      .then(this.resolve)
      .then(({ json }) => this.portCheerFromApi(json as CheerApi))
      .catch(this.reject);
  }

  getCheers(form: CheersInterface.GetCheersForm): Promise<CheersInterface.GetCheersResponse> {
    return this.http
      .get(`channels/${form.channelId}/cheers`)
      .then(this.resolve)
      .then(({ json }) => (json as CheerApi[]).map((cheer) => this.portCheerFromApi(cheer)))
      .catch(this.reject);
  }

  getCheerers(form: CheersInterface.GetCheerersForm): Promise<CheersInterface.GetCheerersResponse> {
    const queryParam = form.period === getCheerersPeriod.today ? "?period=today" : "";

    return this.http
      .get(`channels/${form.channelId}/cheerers${queryParam}`)
      .then(this.resolve)
      .then(({ json }) => json as CheersInterface.GetCheerersResponse)
      .catch(this.reject);
  }
}

export default CheersApiService;
